export class ModelDefaults {

	static Tenant = () => ({
		id: '',
		name: '',
		slug: '',
		logo_url: '',
		icon_url: ''
	})

	static User = () => ({
		id: '',
		first_name: '',
		last_name: '',
		display_name: '',
		email: '',
		email_is_verified: false,
		avatar_url: ''
	})

	static Game = () => ({
		id: '',
		title: '',
		status: 'ACTIVE',
		description: '',
		arena: false,
		arena_url: '',
	})

	static Sprint = () => ({
		id: '',
		game_id: null,
		label: '',
		total_prize_pool: 0,
		current: false,
		time_start: null,
		time_end: null,
	})

	static Action = () => ({
		action_id: '',
		sprint_id: '',
		enabled: true,
		priority: null,
		amount: 0,
		label: 'New Action',
		description: '',
		connector_type: '',
		bg_color: '#5abd0a',
		text_color: '#ffffff',
		icon: 'far fa-plus-circle',
		show_notification: true,
		protected: false,
		counts_towards_sales: true,
		hasMission: false,
		hashtag: '',
		mission: {
			quantity_needed: 0,
			lock_associated_action: false
		},
		hasGoal: false,
		goal: {
			type: 'ACTION',
			quantity_needed: 0,
			currency: null,
			coin_division: 'PERSON'
		},
	})

	static Reward = () => ({
		id: '',
		enabled: true,
		label: '',
		description: '',
		coins_needed: null,
		qty_available: null,
		show_notification: true
	})

	static Tip = () => ({
		id: '',
		label: '',
		description: '',
		content: '',
		link: '',
		link_text: 'Go To Link',
		video_id: '',
		video_type: '',
		user_type: 'all'
	})

}